import React from 'react';
import DaySelectComponent from '../../components/Filters/daySelect';
import dateToString from '../../helpers/dateToString';
import stringToDate from '../../helpers/stringToDate'
class DaySelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            minDate: new Date(),
            maxDate: new Date(),
        }
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        this.setInitialState();
    };

    componentDidUpdate(prevProps){
        if (prevProps.filters !== this.props.filters) {
            this.setInitialState();
        }
    }

    notifyParentFilter(fromDate, untilDate){
        const { id, handleTimeSelect } = this.props;

        if((fromDate === undefined) || (fromDate === null) || (untilDate === undefined) || (untilDate === null)){
            return
        }

        if(handleTimeSelect !== undefined){
            var data = {
                fromDate: fromDate,
                untilDate: untilDate,
                filterId: id
            }
            handleTimeSelect(data);
        }
    }

    /**
     * Asigna valor de día.
    */
    setInitialState(){
        const { id, name, data, updateFiltersMessage, defines } = this.props;
        var parametersArray = [];
        var parameters = '';

        const dateString = data[0];

        const minDateString = defines[0].value;
        const maxDateString = defines[1].value;

        const date = stringToDate(dateString);
        const minDate = stringToDate(minDateString);
        var maxDate = stringToDate(maxDateString);
        maxDate = maxDate < date ? date : maxDate;

        this.setState({ 
            date: date,
            minDate: minDate,
            maxDate: maxDate
         });

        parametersArray.push(
            '<parameter>',
            '<name>',
            dateString,
            '</name>',
            '</parameter>'
        );

        parameters = parametersArray.join('');
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }
        updateFiltersMessage(message);
        this.notifyParentFilter(dateString, dateString);
    }

    /**
     * Asigna fecha seleccionada y actualiza filtros con dicha fecha.
     * @param {Date} date - Fecha seleccionada en calendario.
    */
    handleDateChange(date) {
        var parametersArray = [];
        var parameters = '';

        this.setState({ date: date })
        const { id, name, updateFiltersMessage } = this.props;
        var dateString = '';
        if (date != null){
            dateString = dateToString(date);
        }
        
        parametersArray.push(
            '<parameter>',
            '<name>',
            dateString,
            '</name>',
            '</parameter>'
        );

        parameters = parametersArray.join('');
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }
        updateFiltersMessage(message);
        this.notifyParentFilter(dateString, dateString);
    };

    render() {
        const { date, minDate, maxDate } = this.state;
        const { required } = this.props;

        return (
            <DaySelectComponent
                date={date}
                handleDateChange={this.handleDateChange}
                required={required}
                minDate={minDate}
                maxDate={maxDate}
            />
        )
    }
}

export default DaySelect;